import * as Swetrix from "swetrix";
import { isAnalyticsEnabled } from "@/lib/consent";

const toStringMeta = (obj = {}) => {
  const out = {};
  Object.entries(obj).forEach(([k, v]) => {
    if (v !== undefined && v !== null) out[k] = String(v);
  });
  return out;
};

// Fires a custom event to both Swetrix and Google Analytics (if loaded).
// Gated on cookie consent — no-ops until the visitor accepts.
export const trackEvent = (swetrixEvent, gaEvent, params = {}) => {
  if (!isAnalyticsEnabled()) return;
  try { Swetrix.track({ ev: swetrixEvent, meta: toStringMeta(params) }); } catch (e) { console.debug("analytics: Swetrix track failed", e); }
  try { if (window.gtag) window.gtag("event", gaEvent, params); } catch (e) { console.debug("analytics: GA track failed", e); }
};
